module.exports = __webpack_public_path__ + "img/Group 3000.b37afc4d.svg";